<template>
  <button
    v-if="tooltipImg"
    v-b-tooltip="{
      customClass: 'tooltipContainer',
      trigger: 'hover',
      title: 'Favorilere Ekle',
      html: true,
      placement: 'top',
    }"
    type="button"
    class="btn shadow-none border-none"
    :class="tooltipClass"
    @click="clickEvent($event)"
  >
    <img :src="require('../../../public/src/images/' + tooltipBtnImg)" :alt="tooltipBtnImg" />
    {{ tooltipBtnTitle }}
  </button>
  <button
    v-else
    v-b-tooltip="{
      customClass: 'tooltipContainer',
      trigger: 'hover',
      title: 'Favorilere Ekle',
      html: true,
      placement: 'top',
    }"
    type="button"
    class="btn"
    :class="tooltipClass"
    @click="clickEvent($event)"
  >
    {{ tooltipBtnTitle }}
  </button>
</template>

<script>
export default {
  name: "TooltipsComponent",
  props: {
    tooltipTitle: {
      type: String,
      default: "Favorilere Ekle",
    },
    tooltipClass: {
      type: String,
      default: "customTooltip",
    },
    tooltipPlacement: {
      type: String,
      default: "top",
    },
    tooltipBtnTitle: {
      type: String,
      default: "",
    },
    tooltipImg: {
      type: Boolean,
      default: false,
    },
    tooltipBtnImg: {
      type: String,
      default: "icon-btn-add.svg",
    },
  },
  methods: {
    clickEvent(event) {
      this.$emit("clickEvent", event);
    },
  },
};
</script>

<style scoped lang="scss">
.tooltipContainer {
  .tooltip-inner {
    text-align: left;
  }

  // `fade` ve `show` sınıfları yoksa koy
  &:not(.fade):not(.show) {
    opacity: 1;
    outline: 0;
    display: block;
  }
}
</style>
